import React, { useState } from 'react';
import ReactGA from 'react-ga';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import Head from './components/Head';
import Header from './components/Header';
import Podcast from './components/Podcast';
import ContactUs from './components/ContactUs';
import SocialFeed from './components/SocialFeed';
import ListenButtons from './components/ListenButtons';

import './App.css';

ReactGA.initialize('UA-178534227-1');
ReactGA.pageview(window.location.pathname + window.location.search);

const App = () => {
  const [podcastPostion, setPodPosition] = useState(null);
  const [socialPostion, setSocialPosition] = useState(null);

  const getLinkedType = (type = 'empty') => {
    const position = (type === 'podcast') ? podcastPostion : socialPostion;
    
    window.scrollTo({
      top: position - 50,
      left: 0,
      behavior: 'smooth'
    });
  }

  const getPodPosition = (position = 'empty') => setPodPosition(position);

  const getSocialPosition = (position = 'empty') => setSocialPosition(position);

  return (
    <HelmetProvider>
      <div className="App">
        <Helmet>
          <title>Dermatology Uk The Podcast - The podcast where we talk about all things skin.</title>
          <meta name="description" content="The podcast where we talk about all things skin." />
        </Helmet>
        <Header callback={getLinkedType}/>
        <Head />
        <Podcast position={getPodPosition}/>
        <ListenButtons />
        <SocialFeed position={getSocialPosition}/>
        <ContactUs />
      </div>
    </HelmetProvider>
  );
}

export default App;
